/**
 * OrderDetailsPageShell — Feb 2026 (Modern Card Theme · Phase 2)
 *
 * Thin theme-aware switcher for the customer order tracking surface.
 * Renders OrderDetailsPageModern when `ui_theme = 'modern'`, otherwise
 * the legacy OrderDetailsPage (Code theme). Registered in App.js under
 * the `/customer/orders/:orderId` route.
 */
import { useTheme } from '../../context/ThemeContext';
import { OrderDetailsPage as OrderDetailsPageLegacy } from './OrderDetailsPage';
import { OrderDetailsPageModern } from './OrderDetailsPageModern';

export function OrderDetailsPageShell() {
  const { isModern } = useTheme();
  return isModern ? <OrderDetailsPageModern /> : <OrderDetailsPageLegacy />;
}

export default OrderDetailsPageShell;
